var map = {
	"./gallery1.jpg": 8178,
	"./gallery10.jpg": 6638,
	"./gallery11.jpg": 2981,
	"./gallery12.jpg": 85,
	"./gallery2.jpg": 8656,
	"./gallery3.jpg": 1105,
	"./gallery4.jpg": 6968,
	"./gallery5.jpg": 64,
	"./gallery6.jpg": 9440,
	"./gallery7.jpg": 5935,
	"./gallery8.jpg": 7572,
	"./gallery9.jpg": 7450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4083;